<app-header></app-header>
<section style="margin-top:100px">

    <h2>Mystery Box Rewards</h2>
        
<section class="task_center_sec">
    <div class="container">
        <div class="card-grid">
            <div class="card">
                <img src="/assets/images/giftbox.png" alt="Icon">
                <h3>
                    Sign up & Verify 
                    <span class="info-icon" (mouseenter)="openPopUp()" (mouseleave)="closePopup()">i</span>
                </h3>
                <p>Complete KYC Verification to get 1 Mystery Box</p>
                <button class="btn">Expired</button>
            </div>
            
            <div class="card">
                <img src="/assets/images/giftbox.png" alt="Icon">
                <h3>Phone Verification
                    <span class="info-icon" (mouseenter)="openPopUp()" (mouseleave)="closePopup()">i</span>
                </h3>
                
                <p>Complete Phone Verification to get 1 Mystery Box</p>
                <button class="btn">Expired</button>
            </div>
            
            <div class="card">
                <img src="/assets/images/giftbox.png" alt="Icon">
                <h3>Deposit $10
                    <span class="info-icon" (mouseenter)="openPopUp()" (mouseleave)="closePopup()">i</span>
                </h3>
                <p>Deposit Min 10 USDT to get 1 Mystery Box</p>
                <button class="btn">Expired</button>
            </div>
            
            <div class="card">
                <img src="/assets/images/giftbox.png" alt="Icon">
                <h3>Buy/Sell 100 KPK
                    <span class="info-icon" (mouseenter)="openPopUp()" (mouseleave)="closePopup()">i</span>
                </h3>
                <p>Trade Min 100 KPK in KPK/INR Pair to get 1 Mystery Box</p>
                <button class="btn">Expired</button>
            </div>
        </div>
    </div>
</section>
</section>



<div class="popup" *ngIf="popUp">
    <div class="popup-content">
        <span class="close" (click)="closePopup()">&times;</span>
        <h3 style="color: black;">Terms & Conditions</h3>
        
        <ul>
            <li  style="color: black;list-style-type: disc;">
                Mystry Box Will be available immediately After Completing Task.
            </li>
            <li style="color: black;list-style-type: disc;">
Complete the Task Before Expiry.
            </li>
        </ul>
    </div>
</div>

<section style="margin-top:320px">
    <app-footer></app-footer>
</section>
